import { CHIP_SIZE, CHIP_TYPE, Chip } from '@repo/design-system/index'
import { useEffect, useState } from 'react'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'
import Stars from '../../../icon/Stars'

const ReviewItem = ({ item, i }: { item: any; i: number }) => {
  const isMobile = useIsMobile()
  const { t } = useTranslation()
  const [visibleKeywords, setVisibleKeywords] = useState<null | string[]>(null)
  const [hiddenKeywords, setHiddenKeywords] = useState<null | string[]>(null)
  const [isExpanded, setIsExpanded] = useState<null | boolean>(null)

  const visibleCount = 1

  useEffect(() => {
    const keywords = item?.keywords
    if (keywords.length > 3) {
      setVisibleKeywords(keywords.slice(0, visibleCount))
      setHiddenKeywords(keywords.slice(visibleCount))
      setIsExpanded(false)
    } else {
      setVisibleKeywords(keywords)
    }
  }, [item?.keywords])

  return (
    <div key={i} className="py-[16px]">
      <div>
        <div className="mb-16 flex w-full">
          <div className="flex">
            <div className="mr-[8px] flex items-center">
              <Stars stars={item.stars} clx="flex" />
            </div>
            <div className="Body2-14Md text-gray-300">{item.name?.slice(0, 3)}***</div>
          </div>
          <div className="Body2-14Md mx-[8px] text-gray-300">|</div>
          <div className="Body2-14Md text-gray-300">{item.date}</div>
        </div>
      </div>
      {item.comment && <div className="Body1-16Md mb-20 text-gray-700">{item.comment}</div>}
      <div className="Body2-14Bd flex flex-wrap gap-[8px]">
        {visibleKeywords &&
          visibleKeywords.map((keyword, i) => (
            <Chip customBgColor={COLORS.GRAY100} key={`item-${i}`} type={CHIP_TYPE.ACTIONABLE} size={CHIP_SIZE.MD}>
              <Chip.Label customTxtColor={COLORS.GRAY500}>{keyword}</Chip.Label>
            </Chip>
          ))}
        {hiddenKeywords && !isExpanded && (
          <Chip
            key={`item-${i}`}
            onClick={() => setIsExpanded(true)}
            customBgColor={COLORS.GRAY100}
            type={CHIP_TYPE.ACTIONABLE}
            size={CHIP_SIZE.MD}
          >
            <Chip.Label customTxtColor={COLORS.GRAY500}> +{hiddenKeywords.length}</Chip.Label>
          </Chip>
        )}
        {isExpanded &&
          hiddenKeywords.map((keyword, i) => (
            <Chip customBgColor={COLORS.GRAY100} key={`item-${i}`} type={CHIP_TYPE.ACTIONABLE} size={CHIP_SIZE.MD}>
              <Chip.Label customTxtColor={COLORS.GRAY500}>{keyword}</Chip.Label>
            </Chip>
          ))}
      </div>
    </div>
  )
}

export default ReviewItem
